import { constants } from '@devhub/core'

export const EMPTY_ARRAY = constants.EMPTY_ARRAY
export const EMPTY_OBJ = constants.EMPTY_OBJ
